import type { ReadonlyDeep } from 'type-fest';

import type { MissionStateForm_MissionArchiveInfo } from '../fragments/mission-archive-info.fragment';

export function isMissionArchiveInfoComplete(
  draft: ReadonlyDeep<Partial<MissionStateForm_MissionArchiveInfo>>,
): boolean {
  const isDateOrderValid =
    !draft.startDateForAnalytics ||
    !draft.endDateForAnalytics ||
    draft.startDateForAnalytics <= draft.endDateForAnalytics;

  return (
    !!draft.archiveBinders?.length &&
    !!draft.startDateForAnalytics &&
    !!draft.endDateForAnalytics &&
    isDateOrderValid &&
    !!draft.iHavedCheckedThatReportHasBeenUploaded &&
    !!draft.iHavedCheckedThatPlansHaveBeenUploaded &&
    !!draft.iHavedCheckedThatQuotationHasBeenUploaded &&
    !!draft.iHavedCheckedThatHypothesisNotesHaveBeenUploaded
  );
}
